<template>
    <div class="user-info" @click="toMe">
        <div class="g-flex-center">
            <div class="avatar" :class="{ bd: userInfo.id, man: userInfo.sex !== '女' }" ></div>
            <div>
                <p class="name">
                    <span :class="{ a: userInfo.id }">{{ userInfo.id ? userInfo.name : '' }}</span>
                    <span class="lv" v-if="userInfo.id">
                        <span class="sp">|</span>
                        <span class="companyName">{{ userInfo.companyName }}</span>
                    </span>
                </p>
                <p class="sub-desc" v-if="userInfo.id">(累积积分：{{ userInfo.totalPoint }}&nbsp;&nbsp;剩余积分：{{ userInfo.availablePoint }})</p>
            </div>
        </div>
        <van-icon name="arrow" class="arrow-icon" v-if="userInfo.id"></van-icon>
    </div>
</template>

<script >
export default {
  props: {
    userInfo: {
        type: Object,
        default: () => ({})
    }
  },
  methods: {
    toMe () {
      this.$router.push('/member-me')
    }
  }
}
</script>

<style lang="scss" scoped>
.user-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: calc(var(--gap) * 20) 0 calc(var(--gap) * 16) 0;
    .g-flex-center{
        display: flex;
        align-items: center;
    }
    .avatar {
        margin-right: calc(var(--gap) * 12);
        width: calc(var(--w) * 48);
        height: calc(var(--w) * 48);
        box-sizing: border-box;
        // border: 2px solid #fff;
        border-radius: 50%;
        overflow: hidden;
        background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/member/avatar-fe.png);
        background-size: cover;
        &.man{          
          background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/member/avatar-man.png);
        }
    }
    .avatar.bd {
        border: 1px solid #ddd;
    }
    p{
        margin: 0;
        padding: 0;
    }
    .name {
        font-size:var(--fs-ex2);
        color: var(--g8);
        font-weight: var(--bold);
        .lv {
            color:var(--g7);
            font-weight: normal;
            .sp {
                margin: 0 calc(var(--gap) * 10);
            }
            .companyName {
                font-size:var(--fs-md);
                display: inline-block;
                max-width: calc(var(--w) * 120);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                vertical-align: middle;
            }
        }
        .a {
            max-width: calc(var(--w) * 120);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
        }
    }
    .sub-desc {
        margin-top: calc(var(--gap) * 4);
        color: var(--g7)
    }
    .arrow-icon {
        color: var(--g7)
    }
}
</style>
